module.exports = __webpack_public_path__ + "static/media/webdesign-services-img58.70d2fdd8.jpg";